export const isCommentEdited = (commentLike) => {
  if (!commentLike) return false;
  if (commentLike.isEdited === true) return true;

  if (!commentLike.updatedAt || !commentLike.createdAt) {
    return false;
  }

  const updatedAtMs = new Date(String(commentLike.updatedAt)).getTime();
  const createdAtMs = new Date(String(commentLike.createdAt)).getTime();

  if (!Number.isFinite(updatedAtMs) || !Number.isFinite(createdAtMs)) {
    return false;
  }

  return updatedAtMs > createdAtMs;
};
